module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('NbFilter', {
    attrs: {
      "pager": _vm.pager,
      "callback": _vm.search
    }
  })], 1), _vm._v(" "), _vm._l((_vm.pager.users), function(user) {
    return _c('div', {
      staticClass: "col-xs-12 bg-white pv10 mt10 cursor",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.$router.push('/cgd/by/user/profile/' + user.id)
        }
      }
    }, [_c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [(user.avatar && user.avatar.url) ? _c('img', {
      staticClass: "img-rounded img-md",
      attrs: {
        "src": user.avatar.url
      }
    }) : _c('img', {
      staticClass: "img-rounded img-md",
      attrs: {
        "src": require("../../../common/assets/img/avatar.png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "pull-right action-buttons"
    }, [_c('a', {
      attrs: {
        "title": "编辑"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.$router.push('/cgd/by/user/edit/' + user.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil text-info f20"
    })]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "title": "删除"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.confirmDel(user)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash text-danger f20"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('div', [_c('span', {
      staticClass: "f15"
    }, [_vm._v(_vm._s(user.nickname))]), _vm._v(" "), _vm._l((user.tags), function(tag) {
      return _c('span', {
        staticClass: "mr5 label label-default"
      }, [_vm._v(_vm._s(user.role.name))])
    })], 2), _vm._v(" "), _c('small', {
      staticClass: "block m-t-xs m-b-xs text-muted"
    }, [_vm._v(_vm._s(user.description))]), _vm._v(" "), _c('span', {
      staticClass: "mr10"
    }, [_vm._v("#" + _vm._s(user.id))]), _vm._v(" "), _c('span', {
      staticClass: "mr10"
    }, [_vm._v("上次登录: " + _vm._s(_vm._f("simpleDateTime")(user.lastTime)))]), _vm._v(" "), _c('span', {
      staticClass: "mr10"
    }, [_vm._v("上次IP: " + _vm._s(user.lastIp))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 mt20"
  }, [_c('NbPager', {
    attrs: {
      "pager": _vm.pager,
      "callback": _vm.refresh
    }
  })], 1)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-fire text-success"
  }), _vm._v(" "), _c('span', [_vm._v("用户列表")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-19ef1843"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/user/List.vue
// module id = 954
// module chunks = 1